<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { TravelDirection } from '@/shared/types/common.types'
  import { FlowTravelersWidgetQC } from '@/widgets/Flow'

  useApiRequestsAbort()
</script>

<template>
  <FlowTravelersWidgetQC :type-of-travel="TravelDirection.INBOUND" />
</template>
